import * as React from "react";
import * as style from "./imgSection.module.scss";
import { GatsbyImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";

const ImgSection = ({
  img,
  staticImg,
  alt,
  heading,
  spacingTop,
  spacingBottom,
  spacingLeft,
  spacingInline,
  ...other
}) => {
  return (
    <section
      className={`
        ${style.ImgSection}
        ${heading ? style.ImgSection___heading : ""}
        ${spacingTop ? style.ImgSection___spacingTop : ""}
        ${spacingBottom ? style.ImgSection___spacingBottom : ""}
        ${spacingLeft ? style.ImgSection___spacingLeft : ""}
        ${spacingInline ? style.ImgSection___spacingInline : ""}
      `.trim()}
      {...other}
    >
      {img && (
        <GatsbyImage image={img} alt={alt} className={style.ImgSection_img} />
      )}
      {staticImg && <img src={staticImg} alt={alt} />}
    </section>
  );
};

export default ImgSection;

ImgSection.propTypes = {
  img: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  alt: PropTypes.string,
  heading: PropTypes.bool,
  spacingTop: PropTypes.bool,
  spacingBottom: PropTypes.bool,
  spacingLeft: PropTypes.bool,
  spacingInline: PropTypes.bool,
};

ImgSection.defaultProps = {
  alt: "",
};

ImgSection.displayName = "ImgSection";
